module.exports = __webpack_public_path__ + "img/icon-medium-blue.e13c6a3e.svg";